const tones = {
  neutral: 'border-white/10 bg-white/[.035] text-slate-400',
  success: 'border-emerald-400/20 bg-emerald-400/8 text-emerald-300',
  warning: 'border-amber-400/20 bg-amber-400/8 text-amber-300',
  error: 'border-rose-400/20 bg-rose-400/8 text-rose-300',
  accent: 'border-cyan-300/20 bg-cyan-300/8 text-cyan-200',
};
export function Badge({ children, tone = 'neutral' }) {
  return <span className={`inline-flex items-center border px-2 py-1 text-[9px] font-bold uppercase tracking-[.13em] ${tones[tone]}`}>{children}</span>;
}
